import api from '../Api';

export const fetchBusinessApplications = async () => {
  try {
    const response = await api.get('/admin/applications?populate=serviceType');
    // Return the array directly, the hook will handle it
    return response.data?.applications || [];
  } catch (error) {
    console.error('Error fetching business applications:', error);
    throw error;
  }
};

export const processBusinessApplications = (applications = []) => {
  return applications.map(application => {
    let founded_year = 'N/A';
    try {
      const formattedDate = new Date(application?.founded_Year || application?.yearEstablished);
      founded_year = isNaN(formattedDate.getFullYear())
        ? 'N/A'
        : formattedDate.getFullYear().toString();
    } catch (e) {
      console.warn(`Invalid date for business: ${application.name}`);
    }

    return {
      ...application,
      founded_year,
      company: application.name || 'Unknown Company',
    };
  });
};
